export default "__VITE_ASSET__d33d087e__"